import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
@Component({
  selector: 'client-purchasing-file-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
})
export class FileUploadComponent implements OnInit {
  @Input() labelName?: string;
  @Input() isRequired?: boolean;
  @Input() submitted?: boolean;
  @Input() isDisabled: boolean = false;
  @Output() fileValueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isValid?: Boolean;
  @Output() removeFileRequested = new EventEmitter<number>();
  index!: number;

  constructor(
    private utilityService: UtilityService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {}

  onRemoveFile(index: number) {
    this.removeFileRequested.emit(index);
  }

  async onFileChange($event: Event | null): Promise<void> {
    let file = null;
    if ($event) {
      const input = $event.target as HTMLInputElement;
      file = input.files![0];

      if (file) {
        if (this.utilityService.isFileEmptyOrCorrupted(file)) {
          this.notificationService.showError(
            this.utilityService.getCorruptedOrEmptyFileMessage(),
            'Invalid File',
          );
          input.value = '';
          this.fileValueChanged.emit(null);
          return;
        }

        if (!this.utilityService.isFileTypeAllowed(file)) {
          this.notificationService.showError(
            this.utilityService.getUnsupportedFileTypeMessage(file.name),
            'Invalid File Type',
          );
          input.value = '';
          this.fileValueChanged.emit(null);
          return;
        }

        const restrictedZipMessage =
          await this.utilityService.getRestrictedZipContentMessage(file);
        if (restrictedZipMessage) {
          this.notificationService.showError(
            restrictedZipMessage,
            'Invalid File Type',
          );
          input.value = '';
          this.fileValueChanged.emit(null);
          return;
        }
      }
    }
    this.fileValueChanged.emit(file);
  }
}
